<template lang="pug">
div
  main
    Intro
    Rating
    Rules#rules
    Rewards

  PromoFooter
</template>

<script>
import PromoFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import Intro from "./blocks/Intro";
import Rating from "./blocks/rating/Rating";
import Rules from "./blocks/Rules";
import Rewards from "./blocks/rewards/Rewards";

export default {
  name: "PromoIndex",

  components: {
    PromoFooter,
    Intro,
    Rating,
    Rules,
    Rewards,
  },
};
</script>
